import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { updatePaymentInfo } from '@/modules/partner/actions/async/updatePaymentInfo';
import { AppDispatch } from '@/root-store';
import { StepLayout } from '@/shared/view/StepLayout';

import { PaymentsForm } from './form';

interface IProps {
  onGoBack: () => unknown;
}

const EditPayments = ({ onGoBack }: IProps) => {
  const dispatch = useDispatch() as AppDispatch;
  const intl = useIntl();

  const postForm = useCallback(
    async (formValues: Parameters<typeof updatePaymentInfo>[0]) => {
      const resultAction = await dispatch(updatePaymentInfo(formValues));

      if (updatePaymentInfo.fulfilled.match(resultAction)) {
        const { isSucceed, result = {} } = resultAction.payload;

        if (isSucceed && !result.validationErrors && !result.baseErrors) {
          onGoBack();
        }

        return result;
      }

      return {};
    },
    [dispatch, onGoBack],
  );

  return (
    <StepLayout
      onClickBack={onGoBack}
      hideProgress={true}
      title={intl.formatMessage({
        defaultMessage: 'Payment information',
        id: 'kKfEj5',
        description: 'Edit payments screen: title',
      })}
    >
      <PaymentsForm
        usePreSaveStore={false}
        onSubmit={postForm}
        textSubmitButton={
          <FormattedMessage defaultMessage="Save" id="RT8KNi" description="Save button text" />
        }
      />
    </StepLayout>
  );
};

export { EditPayments };
